import React from 'react'
import ApiUrl from '../../../../../configTools/apiUrl'
import { useRef,useState,useEffect } from 'react'
import { ReactComponent as CrossIcon} from '../../../../../images/icons/cross.svg'
import Logo from '../../../../../images/logo4white.png'
import { Link } from 'react-router-dom'


const ViewPop = ({reel,setSelectedReel}) => {
    const videoFile = useRef(null);
    const [isPlaying,setIsPlaying] = useState(false);
    useEffect(()=>{
        videoFile.current.onplay = ()=>{
            setIsPlaying(true)
        }
        videoFile.current.onpause = () => {
            setIsPlaying(false);
        };
        videoFile.current.play()
    },[])
  return (
    <div className='profile_show_reel_pop_wrapper'>
        <div className='profile_show_reel_pop_container'>
            <div className='profile_show_reel_pop_video'>
                <video ref={videoFile} src={ApiUrl.API_URL_Video_HD+reel.video} loop></video>
            </div>
            <div className='profile_show_reel_pop_playpause_controller' onClick={()=>{
                if(isPlaying){
                    videoFile.current.pause();
                }
                else{
                    videoFile.current.play();
                }
            }}></div>
            <div className='profile_show_reel_pop_playpause_discription'>
                <div className='profile_show_reel_pop_playpause_paragraph'>
                    <p>{reel.discription}</p>
                </div>
                <div className='profile_show_reel_pop_playpause_usernbutton'>
                    <div className='profile_show_reel_pop_playpause_userdetails'>
                        <div style={{
                            width: "40px",
                            paddingTop: "40px",
                            borderRadius: "5px",
                            position: "relative",
                            backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+reel.userimage})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center'
                        }}></div>
                        <Link to={'/user/'+reel.username}>
                            <div className='profile_show_reel_pop_playpause_userdetails_name'>
                                <h5>{reel.userfirstname} {reel.userlastname}</h5>
                                <p>{reel.username}</p>
                            </div>
                        </Link>
                    </div>
                    <Link to={'/product/'+reel.productslug}>
                        <button>
                            Shop
                        </button>
                    </Link>
                </div>
            </div>
        </div>
        <div className='profile_show_reel_pop_logo'>
            <img src={Logo}/>
        </div>
        <div className='profile_show_reel_pop_closebutton' onClick={()=>{setSelectedReel(0)}}>
            <CrossIcon />
        </div>
    </div>
  )
}

export default ViewPop
